import { Component, Input, ViewChildren } from '@angular/core';
import { MenuCommand } from '../../../shared/models/menu-command';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';

import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lfw-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
  imports: [MatMenuTrigger, MatMenu, MatMenuItem, RouterLink, MatIcon, RouterLinkActive]
})
export class MenuComponent {
  @Input() menuItems: MenuCommand[] | null = [];
  @ViewChildren('menuButton', { read: RouterLinkActive }) routerlinks: RouterLinkActive[] = [];

  openHelp(cmd: MenuCommand): void {
    if (!cmd.isExternalRoute) {
      return;
    }
    window.open(cmd.route, '_blank');
  }
  get anyActiveLink() {
    return this.routerlinks.some((link) => link.isActive);
  }
}
